export default "__VITE_ASSET__J9U2I4Rb__"